<template>
  <AppDialog
    v-model="isDialogOpen"
    header="Unsaved Changes"
    message="Are you sure you want to leave without saving?"
    @click:close="$emit('close')"
  >
    <template #actions>
      <AppButton
        variant="outline"
        label="Continue Editing"
        @click="handleCancel"
      />
      <AppButton
        variant="primary"
        label="Leave Without Saving"
        @click="handleDelete"
      />
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue', 'resolve', 'close'])

const isDialogOpen = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emit('update:modelValue', value)
  },
})

function handleDelete() {
  emit('resolve', true)
  isDialogOpen.value = false
}

function handleCancel() {
  emit('resolve', false)
  isDialogOpen.value = false
}
</script>
